var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystem({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7358 4.14062H3.26809C2.85636 4.14062 2.51953 4.47747 2.51953 4.88918V16.117C2.51953 16.5287 2.85638 16.8655 3.26802 16.8655H9.10648L8.35799 19.1111H6.63646V19.8595H15.0948L16.7415 19.8596V19.1111H14.9076L14.2339 16.8656L19.7355 16.8655C20.1472 16.8655 20.484 16.5287 20.484 16.117L20.4841 4.88918C20.4841 4.47746 20.1473 4.14062 19.7355 4.14062H19.7358ZM18.9873 14.62C18.9873 15.0317 18.6505 15.3685 18.2388 15.3685H4.76543C4.35377 15.3685 4.01693 15.0317 4.01693 14.62L4.01687 6.38632C4.01687 5.97466 4.35372 5.63783 4.76536 5.63783H18.2387C18.6504 5.63783 18.9872 5.97468 18.9872 6.38632L18.9873 14.62Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystem);
export default __webpack_public_path__ + "static/media/System.e95968c1e22de42372249350659efee9.svg";
export { ForwardRef as ReactComponent };